import { useMemo } from 'react';
import { Button } from '../../components/Button';
import { Modal } from '../../components/Modal';
import { formatCurrency } from '../../utils/formatCurrency';
import {
  FooterContent,
  FooterLeft,
  FooterTitle,
  FooterTotal,
  GuestInfo,
  GuestList,
  GuestName,
  GuestPrice,
  GuestRow,
  Indicator,
} from './GuestSelectModal.styles';
import type { GuestSelectModalProps } from './GuestSelectModal.types';

export function GuestSelectModal({
  open,
  onClose,
  guests,
  onToggleGuest,
  onConfirm,
  extraTitle,
  currencyCode = 'GBP',
  locale = 'en-GB',
  labels = {},
}: GuestSelectModalProps) {
  const { title = 'Select guests', close = 'Close', total = 'Total', confirm = 'Confirm' } = labels;

  const totalAmount = useMemo(
    () => guests.filter((g) => g.selected).reduce((sum, g) => sum + g.price.amount, 0),
    [guests]
  );

  const footer = (
    <FooterContent>
      <FooterLeft>
        {extraTitle && <FooterTitle>{extraTitle}</FooterTitle>}
        <FooterTotal>
          {total} {formatCurrency(totalAmount, currencyCode, { locale })}
        </FooterTotal>
      </FooterLeft>
      <Button variant="primary" size="small" onClick={onConfirm}>
        {confirm}
      </Button>
    </FooterContent>
  );

  return (
    <Modal open={open} onClose={onClose} title={title} footer={footer} labels={{ close }}>
      <GuestList>
        {guests.map((guest) => (
          <GuestRow
            key={guest.id}
            $selected={guest.selected}
            type="button"
            onClick={() => onToggleGuest(guest.id)}
            aria-pressed={guest.selected}
          >
            <GuestInfo>
              <GuestName>{guest.label}</GuestName>
              <GuestPrice>
                + {formatCurrency(guest.price.amount, guest.price.currencyCode, { locale })}
              </GuestPrice>
            </GuestInfo>
            <Indicator $selected={guest.selected} />
          </GuestRow>
        ))}
      </GuestList>
    </Modal>
  );
}
